// import import 'bootstrap/js/dist/collapse';
import { Collapse } from "bootstrap";

var collapseElementList = [].slice.call(document.querySelectorAll('.collapse'));
var collapseList = collapseElementList.map(function (collapseEl) {
  return new Collapse(collapseEl, {toggle: false});
})
